export default "__VITE_ASSET__BZ4PG7mY__"